module.exports = __webpack_public_path__ + "img/PLAN VOLVO TRUCKS.df70a869.jpg";